/**
 * The adjustment is 10% of the quantity selected by the user
 * Example: Quantity: 21 m3, Adjustment: 2.1m3
 */
export function calculateAdjustmentQuantity(number: number, decimalLimit?: number): string {
  return (number * 0.1).toFixed(decimalLimit);
}
